import React from "react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const styles = {
  mainBanner: {
    position: "relative",
    width: "100%",
  },
  mySwiper: {
    width: "100%",
    height: "100%",
  },
  item: {
    position: "relative",
    backgroundSize: "100% auto",
    backgroundPosition: "center top",
    backgroundRepeat: "no-repeat",
    height: "700px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "0 50px",
    overflow: "hidden",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "transparent",
    zIndex: 1,
  },
};

const MainBanner = () => {
  const [windowSize, setWindowSize] = React.useState({
    width: undefined,
  });

  React.useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowSize.width <= 768;
  const isSmallMobile = windowSize.width <= 480;

  const calculateHeightFromWidth = () => {
    const width = windowSize.width || 1920;
    const height = (width * 1080) / 1920;

    return `${Math.round(height)}px`;
  };

  const itemStyle = {
    ...styles.item,
    height: calculateHeightFromWidth(),
    padding: isMobile ? "0 20px" : "0 50px",
  };

  return (
    <div style={styles.mainBanner} className="main-banner">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={10}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        className="mySwiper"
        style={styles.mySwiper}
      >
        <SwiperSlide>
          <div
            style={{ ...itemStyle, ...styles.item1 }}
            className="item item-1"
          >
            <div style={styles.overlay}></div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div
            style={{ ...itemStyle, ...styles.item2 }}
            className="item item-2"
          >
            <div style={styles.overlay}></div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div
            style={{ ...itemStyle, ...styles.item3 }}
            className="item item-3"
          >
            <div style={styles.overlay}></div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default MainBanner;
